import { CdkService, ApiError } from 'api-new/generated';
import { formatErrorMessage } from 'features/shared/model';
import { UseMutationOptions, useMutation } from 'react-query';
import { toast } from 'react-toastify';

export type CdkUpdateMileageInput = {
  branchId: number;
  cdkVehicleId: string;
  mileage: number;
};

export const useCdkUpdateMileageMutation = (
  options?: Omit<
    UseMutationOptions<
      Awaited<ReturnType<typeof CdkService.postCdkVehiclesVehicleUpdateMileage>>,
      ApiError,
      CdkUpdateMileageInput,
      unknown
    >,
    'mutationFn'
  >
) =>
  useMutation(
    ({ branchId, cdkVehicleId, mileage }: CdkUpdateMileageInput) =>
      CdkService.postCdkVehiclesVehicleUpdateMileage(branchId, cdkVehicleId, {
        mileage: { value: mileage }
      }),
    {
      ...options,
      onError: (error: ApiError, variables, context) => {
        const message = formatErrorMessage(error);
        toast.error(message);
        console.error(message);
        options?.onError?.(error, variables, context);
      }
    }
  );
